export default __webpack_public_path__ + "static/media/prokat_1.9657cf81.webp";